var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7303_38666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37263 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73926 12H9.78654L6.26098 7.82611L5.73926 9.39131V12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 9.78646L7.82617 5.73914H12.0001L12.0001 9.78646Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9678 12H11.9999C11.9999 11.9892 11.9999 11.9787 11.9999 11.9679C11.9892 11.9786 11.9785 11.9893 11.9678 12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.26086C12 4.14938 12 2.76581 12 0H11.998C5.3715 0.001125 0 5.37323 0 12H6.26091V8.47448L9.78642 12H11.968C11.9787 11.9893 11.9894 11.9786 12.0001 11.9679C12.0001 11.1594 12.0001 10.4381 12.0001 9.78647L8.47444 6.26086H12Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.071 1.56522C4.19417 2.63392 2.63389 4.1942 1.56519 6.07103V12H4.69564V4.69576V4.69567H12C12 3.70834 12 2.76775 12 1.56522H6.071Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 10.5243L7.73661 6.26093H6.26099V6.26102L12 12H12.0001C12.0001 12 12.0001 10.9825 12.0001 10.5243V10.5243Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0972 19.8261L13.3562 20.6233H14.1944L13.5163 21.1159L13.7753 21.913L13.0972 21.4204L12.4191 21.913L12.6781 21.1159L12 20.6233H12.8381L13.0972 19.8261Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7725 14.6087L20.0315 15.4058H20.8697L20.1916 15.8985L20.4507 16.6956L19.7725 16.203L19.0944 16.6956L19.3535 15.8985L18.6753 15.4058H19.5135L19.7725 14.6087Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4451 6.78262L21.7041 7.57978H22.5423L21.8642 8.07244L22.1232 8.86954L21.4451 8.37694L20.767 8.86954L21.026 8.07244L20.3479 7.57978H21.1861L21.4451 6.78262Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8594 12.5217L22.1184 13.3189H22.9566L22.2785 13.8116L22.5376 14.6087L21.8594 14.1161L21.1814 14.6087L21.4404 13.8116L20.7622 13.3189H21.6004L21.8594 12.5217Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.299 17.9512L15.0459 18.3318L15.6386 17.7391L15.5075 18.5669L16.2543 18.9474L15.4264 19.0786L15.2953 19.9064L14.9148 19.1596L14.0869 19.2908L14.6796 18.6982L14.299 17.9512Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.299 14.8208L15.0459 15.2013L15.6386 14.6087L15.5075 15.4365L16.2543 15.817L15.4264 15.9481L15.2953 16.776L14.9148 16.0292L14.0869 16.1603L14.6796 15.5677L14.299 14.8208Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9076 16.8274L17.6546 17.2079L18.2472 16.6153L18.1162 17.4431L18.8629 17.8236L18.035 17.9547L17.9039 18.7826L17.5235 18.0357L16.6956 18.167L17.2882 17.5743L16.9076 16.8274Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9076 10.1251L17.6546 10.5057L18.2472 9.91302L18.1162 10.7408L18.8629 11.1213L18.035 11.2525L17.9039 12.0803L17.5235 11.3335L16.6956 11.4647L17.2882 10.872L16.9076 10.1251Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4359 10.0448L20.1829 10.4253L20.7755 9.83267L20.6444 10.6605L21.3912 11.041L20.5633 11.1721L20.4322 12L20.0518 11.2532L19.2239 11.3843L19.8165 10.7917L19.4359 10.0448Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7303_38666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.9ffcf5b0f019ee6eb5e7214100757b43.svg";
export { ForwardRef as ReactComponent };